"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var moment = require("moment");
var react_router_dom_1 = require("react-router-dom");
var BlackListDomainRow = /** @class */ (function (_super) {
    tslib_1.__extends(BlackListDomainRow, _super);
    function BlackListDomainRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDelete = function () {
            var _a = _this.props, onDelete = _a.onDelete, item = _a.item;
            onDelete(item);
        };
        return _this;
    }
    BlackListDomainRow.prototype.render = function () {
        var _a = this.props, item = _a.item, sortBy = _a.sortBy;
        return (React.createElement("tr", null,
            React.createElement(ui_1.TableCell, null,
                React.createElement("div", { className: theme.links },
                    React.createElement(ui_1.LinkButton, { onClick: this.onDelete, iconName: "icon-delete", iconSize: 1.8, type: "button" }))),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "domain", maxWidth: 400 }, item.domain),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "country" }, item.country),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "device" }, item.device),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "browser" }, item.browser),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "item" },
                React.createElement(react_router_dom_1.Link, { to: item.itemLink }, item.item)),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "os" }, item.os),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "campaign" }, item.campaign),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "param1" }, item.param1),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "param2" }, item.param2),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "reason" }, JSON.stringify(item.data || {})),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "updated" }, moment.utc(parseFloat(item.updated)).format("MMMM DD YYYY, hh:mm a")),
            React.createElement(ui_1.TableCell, { highlight: sortBy === "created" }, moment.utc(parseFloat(item.created)).format("MMMM DD YYYY, hh:mm a"))));
    };
    BlackListDomainRow.defaultProps = {};
    return BlackListDomainRow;
}(React.Component));
exports.default = BlackListDomainRow;
